module.exports = __webpack_public_path__ + "static/KDDI-96a6fec1eea5f23d8daa8a9302ce6fb2.png";